import { render, staticRenderFns } from "./ProgramDashboardV1.vue?vue&type=template&id=a9fc2f4a&scoped=true"
import script from "./ProgramDashboardV1.vue?vue&type=script&lang=js"
export * from "./ProgramDashboardV1.vue?vue&type=script&lang=js"
import style0 from "./ProgramDashboardV1.vue?vue&type=style&index=0&id=a9fc2f4a&prod&scoped=true&lang=css"
import style1 from "./ProgramDashboardV1.vue?vue&type=style&index=1&id=a9fc2f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc2f4a",
  null
  
)

export default component.exports